<template>
  <div class="lottery-view">
    <el-form ref="form" :model="form" :rules="rules" label-width="135px" size="small">
      <div class="white-container">
        <el-form-item label="开奖标题" prop="lotteryTitle" style="width: 460px">
          <el-input v-model="form.lotteryTitle" placeholder="请输入抽奖名称，最多不超过24个字" maxlength="24" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="简介" prop="introduction" style="width: 80%;margin-top: 10px;">
          <el-input v-model="form.introduction" type="textarea" :rows="4" placeholder="请输入简介" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="奖品配置" prop="prizeInformationAddDTOList">
          <div :class="lottery ? 'lotteryDisabled' : ''" title="已开奖后无法修改" :style="prizeInformationStyle">
            <template v-for="(item, index) in form.prizeInformationAddDTOList">
              <div :key="index" style="margin:20px 0;" :class="lottery? 'lottery-context' : ''">
                <span style="margin-right: 10px">奖品{{ index + 1 }}</span>
                <el-input v-model="item.prizeName" placeholder="请输入奖品名称" style="width: 147px; margin:0 10px 0 0;" :disabled="disabled" />
                <el-input v-model="item.prizeNum" type="number" placeholder="请输入奖品数量" style="width: 147px;margin:0 10px 0 0;" :disabled="disabled" />
                <span v-if="index > 0" class="delPrize" @click="()=>{ form.prizeInformationAddDTOList.splice(index, 1) }">删除</span>
              </div>
            </template>
          </div>
          <el-button v-if="!lottery" class="addPrize" @click="addPrizeItem">+ 新增奖品</el-button>
        </el-form-item>
        <el-form-item label="每人可获抽奖码数" prop="personLotteryCodeNum" style="width: 305px">
          <div class="flex">
            <el-select v-model="form.personLotteryCodeNum" placeholder="请选择抽奖码数" :disabled="disabled">
              <el-option v-for="item in codeNumMap" :key="'CodeNum'+item.id" :label="item.name" :value="item.id" />
            </el-select>
            <div style="margin-left: 6px;">张</div>
          </div>
        </el-form-item>
        <el-form-item label="关联活动" prop="linkObj" style="width: 460px">
          <el-select ref="linkSelect" v-model="form.linkObj" clearable filterable remote placeholder="请选择关联活动" :loading="loading" :remote-method="remoteMethod" value-key="objectId" @keyup.enter.native="selectQuery" @change="handleLinkChange">
            <div slot="empty" :style="emptyTextStyle">请按回车搜索</div>
            <el-option v-for="item in options" :key="item.eventName + item.objectId" :label="item.eventName" :value="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="抽奖规则" prop="lotteryRules" style="width: 80%;margin-top: 10px;">
          <el-input v-model="form.lotteryRules" type="textarea" :rows="4" placeholder="请输入抽奖规则" :disabled="disabled" />
        </el-form-item>

      </div>
      <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
        <div class="flex btns">
          <el-button type="info" @click="cancel">取消</el-button>
          <el-button type="primary" @click="submit">保存</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { Lottery } from '@/model/Lottery';
import Dialog from '@/components/Dialog';
const codeNumMap = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 4, name: '4' },
  { id: 6, name: '6' },
  { id: 8, name: '8' },
  { id: 10, name: '10' },
  { id: 12, name: '12' },
  { id: 14, name: '14' },
  { id: 16, name: '16' },
  { id: 18, name: '18' },
  { id: 20, name: '20' },
];
const prizeInformationStyle = "margin-left:-48px; margin-top:40px; font-family: 'Noto Sans SC'";
const emptyTextStyle = "padding: 0 20px; white-space: nowrap; color: #999; height: 34px; line-height: 34px; box-sizing: border-box; font-family: 'Noto Sans SC';font-size: 14px; font-weight: 400;";
export default {
  components: { Dialog },
  data() {
    return {
      codeNumMap,
      form: new Lottery(),
      lottery: false,
      prizeInformationStyle,
      emptyTextStyle,
      formDialogShow: false,
      information: {},
      cancelTxt: '',
      options: [],
      loading: false,
      errMsg: '',
      rules: {
        lotteryTitle: [
          { required: true, message: '请输入开奖标题', trigger: 'blur' },
        ],
        personLotteryCodeNum: [
          { required: true, message: '请选择每人可获抽奖码数', trigger: 'change' },
        ],
        lotteryRules: [
          { required: true, message: '请输入抽奖规则', trigger: ['change', 'blur'] },
        ],
        prizeInformationAddDTOList: {
          required: true, validator: (rule, value, callback) => {
            if (Array.isArray(value) && value.length) {
              for (let i = 0; i < value.length; i++) {
                if (!value[i].prizeName && !value[i].prizeNum) {
                  callback(new Error('请添加奖品'));
                } else if (!value[i].prizeName) {
                  callback(new Error('请输入奖品名称'));
                } else if (!value[i].prizeNum) {
                  callback(new Error('请输入奖品数量'));
                }
              }
              callback();
            } else {
              callback(new Error('请添加奖品'));
            }
          }, trigger: ['change', 'blur'],
        },
        linkObj: {
          required: true, validator: (rule, value, callback) => {
            if (this.errMsg) {
              callback(new Error(this.errMsg));
            } else if (!value?.objectId || !value?.objectType) {
              callback(new Error('请选择关联活动'));
            } else {
              callback();
            }
          }, trigger: ['change'],
        },
      },
      disabled: false,
      cancelText: "",
      remoteSearchQuery: '',
    };
  },
  mounted() {
    const { query } = this.$route;
    this.id = query.id || query.copyId;
    this.cancelText = query.id ? '编辑' : '新增';
    if (query.id || query.copyId) {
      this.getDetail(this.id);
    }
  },
  methods: {
    remoteMethod(query) {
      this.remoteSearchQuery = query;
    },
    getDetail(id) {
      this.$Api.lottery.getLotteryDetails(id).then(res => {
        this.form = new Lottery(res);
        if (res?.eventName) {
          this.remoteSearchQuery = res.eventName;
          this.selectQuery();
        }
      });
    },
    // 新增奖品
    addPrizeItem() {
      this.form.prizeInformationAddDTOList.push({
        prizeLevel: 1,
        prizeName: "",
        prizeNum: null,
      });
    },
    selectQuery() {
      if (!this.remoteSearchQuery) return;
      this.options = [];
      this.loading = true;
      this.$Api.lottery.getLinkEvents(this.remoteSearchQuery).then(res => {
        this.loading = false;
        if (Array.isArray(res) && res?.length) {
          this.options = res.map(item => {
            item.eventName = item.eventName + ' (ID：' + item.objectId + ')';
            return item;
          });
        } else {
          this.options = [];
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    handleLinkChange() {
      this.errMsg = '';
      this.$refs.form.validateField("linkObj");
    },
    addEditItem() {
      if (this.$route.query.copyId) {
        this.form.id = '';
      }
      this.form.formatForm();
      // this.errMsg = '';
      this.$refs.form.validate(valid => {
        if (valid) {
          const fetchFunc = this.cancelText === '新增' ? this.$Api.lottery.addLottery : this.$Api.lottery.updateLottery;
          fetchFunc(this.form).then(res => {
            this.$message.success(`${this.cancelText}成功`);
            setTimeout(() => {
              this.$router.back(-1);
            }, 2000);
          }).catch(err => {
            if (err && !err.success) {
              if (err?.errorCode === "9023043") {
                this.errMsg = err.errorMessage ? '关联的活动已被' + err.errorMessage : '请重新选择一个活动';
                this.$refs.form.validateField("linkObj");
              }
              console.error(err.errorMessage || `${this.cancelText}失败`);
            }
          });
          // if (this.cancelText === '新增') {
          //   this.$Api.lottery.addLottery(this.form).then(res => {
          //     this.$message.success(`${this.cancelText}成功`);
          //     setTimeout(() => {
          //       this.$router.back(-1);
          //     }, 2000);
          //   }).catch(err => {
          //     if (err && !err.success) {
          //       console.error(err.errorMessage || `${this.cancelText}失败`);
          //     }
          //   });
          // } else if (this.cancelText === '编辑') {
          //   this.$Api.lottery.updateLottery(this.form).then(res => {
          //     this.$message.success(`${this.cancelText}成功`);
          //     setTimeout(() => {
          //       this.$router.back(-1);
          //     }, 2000);
          //   }).catch(err => {
          //     if (err && !err.success) {
          //       console.error(err.errorMessage || `${this.cancelText}失败`);
          //       // this.$message.error(err.errorMessage || `${this.cancelText}失败`);
          //     }
          //   });
          // }
        } else {
          return false;
        }
      });
    },
    dialogSuccess(operation) {
      if (operation === 'cancel') {
        this.$router.go(-1);
      } else if (operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.addEditItem();
          } else {
            return false;
          }
        });
      }
    },
    cancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'cancel',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    submit() {
      this.formDialogShow = true;
      this.information = {
        operation: 'submit',
        icon: 'warn',
        subTitle: "确定保存吗？",
      };
    },
  },
};
</script>
<style lang="less" scoped>
.lottery-view {
  position: relative;
  .marginTop {
    margin-top: 30px;
  }
  :deep(.lng-label .el-form-item__label) {
    width: 50px !important;
  }
  :deep(.lng-label .el-form-item__content) {
    margin-left: 50px !important;
  }
  :deep(.btn-form-item.el-form-item--small) {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .delPrize {
    font-size: 14px;
    color: #0085d0;
    user-select: none;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .addPrize {
    width: 150px;
    height: 34px;
    color: #bbbbbb;
    border: 1px dashed #bbbbbb;
  }
  .lotteryDisabled {
    cursor: not-allowed;
    &:hover {
      &:after {
        position: absolute;
        margin-left: 48px;
        padding: 2px 10px;
        box-shadow: 0 2px 9px #999;
        background-color: #fff;
        border-radius: 4px;
        color: #666;
        content: attr(title);
        z-index: 2;
        line-height: 20px;
        height: 20px;
      }
    }
  }
  .lottery-context {
    pointer-events: none;
  }
}
.btns {
  justify-content: center;
  align-items: center;
  button {
    width: 120px;
    height: 50px;
  }
}
</style>
